import React, {useContext} from "react";
export const ProfileOverlayContext = React.createContext({});

export default function useProfilePopover() {
    return useContext(ProfileOverlayContext);
}